import { motion } from "framer-motion";
import { useState } from "react";
import toast from "react-hot-toast";
import { FiEdit3 } from "react-icons/fi";
import { useAuth } from "../../context/AuthContext";
import StarRating from "../UI/StarRating";

const ReviewForm = ({ siteId }) => {
  const { user, openLogin } = useAuth();
  const [rating, setRating] = useState(0);
  const [title, setTitle] = useState("");
  const [comment, setComment] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!rating) {
      toast.error("Please select a rating");
      return;
    }
    toast.success("Review submitted!");
    setSubmitted(true);
    setRating(0);
    setTitle("");
    setComment("");
    setTimeout(() => setSubmitted(false), 4000);
  };

  if (!user)
    return (
      <div className="card p-8 text-center border-2 border-indigo-100 bg-indigo-50/30">
        <div className="w-12 h-12 rounded-2xl bg-indigo-100 flex items-center justify-center mx-auto mb-3">
          <FiEdit3 size={20} className="text-indigo-600" />
        </div>
        <h3 className="font-extrabold text-slate-900 mb-1">Write a Review</h3>
        <p className="text-sm text-slate-500 mb-4">
          Sign in to share your experience.
        </p>
        <button onClick={openLogin} className="btn-primary">
          Sign In to Review
        </button>
      </div>
    );

  if (submitted)
    return (
      <div className="card p-8 text-center border-2 border-emerald-200 bg-emerald-50">
        <h3 className="font-extrabold text-emerald-800 mb-1">
          Review Submitted!
        </h3>
        <p className="text-sm text-emerald-600">
          Thank you for helping the community.
        </p>
      </div>
    );

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      className="card p-6"
    >
      <h2 className="text-lg font-extrabold text-slate-900 mb-5">
        Write a Review
      </h2>
      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label className="block text-sm font-bold text-slate-700 mb-2">
            Your Rating
          </label>
          <StarRating
            rating={rating}
            size="lg"
            interactive
            onChange={setRating}
          />
          {rating > 0 && (
            <p className="text-xs font-bold text-indigo-600 mt-1.5">
              {
                [
                  "",
                  "Poor",
                  "Below Average",
                  "Average",
                  "Very Good",
                  "Excellent!",
                ][rating]
              }
            </p>
          )}
        </div>
        <div>
          <label className="block text-sm font-bold text-slate-700 mb-1.5">
            Title
          </label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Summarize your experience"
            className="input-field"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-bold text-slate-700 mb-1.5">
            Review
          </label>
          <textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Share your detailed experience with this website..."
            rows={4}
            className="input-field resize-none"
            required
          />
        </div>
        <div className="flex items-center justify-between pt-2">
          <div className="flex items-center gap-2.5">
            <img
              src={user.avatar}
              alt=""
              className="w-8 h-8 rounded-full object-cover ring-2 ring-slate-100"
            />
            <span className="text-sm text-slate-500">
              As <span className="font-bold text-slate-800">{user.name}</span>
            </span>
          </div>
          <button type="submit" className="btn-primary">
            Submit Review
          </button>
        </div>
      </form>
    </motion.div>
  );
};

export default ReviewForm;
